import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

export const header = (isSupplyChainManager = false) => [
  {
    label: 'S.N',
    value: 'S.N',
  },
  {
    label: 'Date',
    value: 'apd',
  },
  // {
  //   label: 'Type',
  //   value: 'wasteSource',
  // },
  // {
  //   label: 'Batch id',
  //   value: 'id',
  // },
  {
    label: 'Product',
    value: 'opname',
  },
  {
    label: 'Batch id',
    value: 'productionId',
  },
  {
    label: 'Quantity',
    value: 'outQty',
  },
  // {
  //   label: isSupplyChainManager ? 'Supply chain' : 'Franchisee',
  //   value: 'franchiseName',
  // },
  {
    label: 'Country',
    value: 'ocountry',
  },
  {
    label: 'site',
    value: 'osite',
  },
  {
    label: 'Recycling Type',
    value: 'processName',
  },
  // {
  //   label: 'Price',
  //   // value: 'price',
  //   value: 'totalAmountI',
  // },
  {
    label: 'feedstock',
    value: 'ORM',
  },
  {
    label: 'GHG value',
    value: 'ghgvo',
  },
  {
    label: 'Saving',
    value: '',
  },
  // {
  //   label: 'Contact',
  //   value: 'customerInfo[mobile]',
  // },
  // {
  //   action: ['view'],
  // },

  // {
  //   label: 'status',
  //   value: 'isscustatus',
  // },

  // {
  //   label: 'Action',
  //   value: 'viewPdf',
  // }
]

const roleColumns = (isSupplyChainManager = false) => {
  return columnGenerators(header(isSupplyChainManager))
}
export { roleColumns }
